import "../css/mainlayout.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { Outlet } from "react-router-dom";
import { useState } from "react";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

library.add(fas, fab);

export default function MainLayout() {
  const [moMenuOpen, setmoMenuOpen] = useState(false);

  useGSAP(() => {
    gsap.registerPlugin(ScrollTrigger);

    gsap.from(".logo", {
      scrollTrigger: {
        trigger: ".logo",
      },
      opacity: 0,
      duration: 1.65,
      ease: "power3.out",
      y: 30,
    });

    gsap.from(".header-nav li", {
      scrollTrigger: {
        trigger: ".header-nav",
      },
      opacity: 0,
      duration: 1.65,
      ease: "power3.out",
      y: 30,
    });

    gsap.from(".header-btn-container ", {
      scrollTrigger: {
        trigger: ".header-nav",
      },
      opacity: 0,
      duration: 1.65,
      ease: "power3.out",
      y: 30,
    });

    gsap.from(".main-footer-container", {
      scrollTrigger: {
        trigger: ".main-footer-container",
        start: "top 70%",
      },
      duration: 1.65,
      ease: "power3.out",
      y: 30,
      opacity: 0,
    });
  });

  return (
    <main>
      <section>
        <div className="header">
          <div className="header-wrapper">
            <div>
              <img src="/logo.webp" alt="logo" className="logo" />
            </div>
            <div className="nav-container">
              <nav className="header-nav">
                <li>
                  <a href="#services">Services</a>
                </li>
                <li>
                  {" "}
                  <a href="#about">About</a>
                </li>
                <li>
                  {" "}
                  <a href="#contact">Contact Us</a>
                </li>
              </nav>
            </div>
            <div className="social-container">
              <FontAwesomeIcon
                icon="fa-brands fa-facebook-f"
                className="social-icon"
              />
              <FontAwesomeIcon
                icon="fa-brands fa-linkedin-in"
                className="social-icon"
              />
            </div>
            <div className="header-btn-container">
              <a className="header-btn" href="null">
                Book consultation
              </a>
            </div>
          </div>
          <div className="mobile-header">
            <div className="mo-header-menu">
              <FontAwesomeIcon
                icon="fa-solid fa-bars"
                className="mo-menu-icon"
                onClick={() => setmoMenuOpen(!moMenuOpen)}
              />
            </div>
            <div className="mo-header-logo">
              <img src="/logo.webp" alt="logo" />
            </div>
            <div className={`mo-nav-container ${moMenuOpen ? "active" : ""}`}>
              <FontAwesomeIcon
                icon="fa-solid fa-xmark"
                className="mo-close-btn"
                onClick={() => setmoMenuOpen(false)}
              />
              <ul className="mo-nav">
                <li>
                  <a href="#services">Services</a>
                </li>
                <li>
                  {" "}
                  <a href="#about">About</a>
                </li>
                <li>
                  {" "}
                  <a href="#contact">Contact Us</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <Outlet />
        <div className="footer">
          <div className="main-footer-container">
            <div className="contact-info-container">
              <div className="text-info">
                <h1>Contact Us</h1>
                <h4>
                  hilary@lawrencelawoffice.net <br />
                  949-257-7116{" "}
                </h4>
                <h4>1201 Puerta Del Sol San Clemente, CA 92673</h4>
                <h4>Monday — Friday 9am — 4pm</h4>
              </div>
              <div className="info-logo">
                <FontAwesomeIcon
                  icon="fa-brands fa-facebook-f"
                  className="info-icon"
                />
                <FontAwesomeIcon
                  icon="fa-brands fa-linkedin-in"
                  className="info-icon"
                />
              </div>
            </div>
            <div className="footer-logo-container">
              <div className="footer-btn-container">
                <a
                  className="footer-btn"
                  href="https://calendly.com/lawrence_law/estate-planning-consultation"
                >
                  Book a Consultation
                </a>
                <p>
                  Access our online scheduling tool, where you can conveniently
                  book a time to speak with an attorney about your estate
                  planning needs.
                </p>
              </div>
              <div className="footer-img-wrapper">
                <img src="logo.webp" alt="logo" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
